import { BankingNextPage } from "./banking-next";

export const BankingPage = () => {
  return <BankingNextPage />;
};
